"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12 0c6.616 0 12 5.384 12 12 0 6.617-5.384 12-12 12-6.617 0-12-5.383-12-12C0 5.384 5.383 0 12 0Zm0 1.067C5.972 1.067 1.066 5.972 1.066 12c0 6.03 4.906 10.934 10.934 10.934 6.029 0 10.934-4.904 10.934-10.934 0-6.028-4.905-10.933-10.934-10.933Zm0 1.39c5.263 0 9.543 4.28 9.543 9.543 0 5.263-4.28 9.543-9.543 9.543-5.262 0-9.542-4.28-9.542-9.543 0-5.262 4.28-9.542 9.542-9.542Zm0 1.067c-4.674 0-8.476 3.803-8.476 8.476 0 4.674 3.802 8.477 8.476 8.477 4.674 0 8.477-3.803 8.477-8.477 0-4.673-3.803-8.476-8.477-8.476Zm4.705 3.073a.532.532 0 0 1 .728.611l-.029.088-2.948 6.88a.546.546 0 0 1-.208.241l-.072.039-6.882 2.95a.535.535 0 0 1-.728-.613l.03-.088 2.948-6.88a.525.525 0 0 1 .206-.242l.073-.038 6.882-2.948ZM15.898 8.1l-5.458 2.34-2.34 5.458 5.46-2.34L15.898 8.1ZM12 10.648c.746 0 1.353.607 1.353 1.352A1.354 1.354 0 1 1 12 10.648Zm0 1.067a.286.286 0 1 0 0 .571.286.286 0 0 0 0-.571Z",
    clipRule: "evenodd"
  })]
});